import http from "api/https";

export const getSignersByDocumentId = (outgoing_document_id: number): Promise<any> => {
  return http.get(`/OutgoingDocumentSigner/GetByDocumentId?outgoing_document_id=${outgoing_document_id}`);
};

export const searchUsersForSigner = (query: string): Promise<any> => {
  return http.get(`/OutgoingDocumentSigner/SearchUsers?query=${encodeURIComponent(query)}`);
};

export const createSigner = (data: { outgoing_document_id: number; user_account_id: number }): Promise<any> => {
  return http.post('/OutgoingDocumentSigner', data);
};

export const deleteSigner = (id: number): Promise<any> => {
  return http.post('/OutgoingDocumentSigner/Delete', { id });
};
